// frontend/src/components/auth/LinkChildForm.tsx
//
// Veli paneli içinde kullanılır: öğrencinin 8 haneli kalıcı kodunu girerek
// hesabına bağlamasını sağlar. Backend'deki POST /api/parent/link-by-code
// endpoint'ini çağırır.

import { useState, FormEvent } from 'react';
import { authService } from '../../services/auth.service';

const API_BASE = (import.meta.env.PROD && (import.meta.env.VITE_API_BASE_URL === 'http://localhost:8080' || !import.meta.env.VITE_API_BASE_URL)) ? '' : (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080');

interface LinkChildFormProps {
  onSuccess?: () => void;
}

export function LinkChildForm({ onSuccess }: LinkChildFormProps) {
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' } | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setMessage(null);
    setIsLoading(true);

    try {
      const token = await authService.getAccessToken();
      const res = await fetch(`${API_BASE}/api/parent/link-by-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ code: code.trim().toUpperCase() }),
      });
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.error?.message || 'Kod doğrulanamadı.');
      }

      setMessage({
        text: `${data.childName || 'Çocuğunuz'} hesabınıza başarıyla bağlandı! 🎉`,
        type: 'success',
      });
      setCode('');
      onSuccess?.();
    } catch (err) {
      setMessage({ text: err instanceof Error ? err.message : 'Bir hata oluştu.', type: 'error' });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="link-child-form">
      <div style={{ marginBottom: 12 }}>
        <p style={{ color: 'var(--gray)', fontSize: 13, lineHeight: 1.6, marginBottom: 12 }}>
          Çocuğunuzun <strong style={{ color: 'var(--white)' }}>Ayarlar</strong> sayfasındaki{' '}
          <strong style={{ color: 'var(--primary-light)' }}>🔑 Öğrenci Kodu</strong>'nu girin.
        </p>
      </div>
      <label htmlFor="student-code" style={{ fontWeight: 600, fontSize: 13, color: 'var(--gray-light)', display: 'block', marginBottom: 8 }}>
        8 Haneli Öğrenci Kodu
      </label>
      <div className="link-child-row">
        <input
          id="student-code"
          type="text"
          placeholder="Örn: A3K7NP2M"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          maxLength={8}
          required
          style={{ fontFamily: 'monospace', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase' }}
        />
        <button type="submit" disabled={isLoading || code.trim().length !== 8}>
          {isLoading ? 'Bağlanıyor...' : 'Bağla'}
        </button>
      </div>
      {message && <p className={`link-child-message ${message.type}`}>{message.text}</p>}
    </form>
  );
}
